export default __webpack_public_path__ + "static/media/step-3-en.cb194c06.png";